import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'tour',
	state : {
		tours: [],
		skip: 0,
		limit: limit,
		total_items: 0
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/tours/list-tours') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {

				let query = {};
				let currentUser = JSON.parse(localStorage.getItem('currentUser'));

				if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) {
					query.client = {
	                    $inQuery: {
	                        where: {
	                            hotel: {__type: 'Pointer', className: 'Hotel', objectId: JSON.parse(localStorage.getItem('currentHotel')).objectId}
	                        },
	                        className: 'Client'
	                    }
	        		}
				}

				if (currentUser.type === 'recepcionista') {
					query.createdBy = {__type: 'Pointer', className: '_User', objectId: currentUser.objectId}
				}

				const resp = yield call(all, 'Tour', {
					where: query,
					include: 'client,client.hotel,createdBy',
					skip: 0, 
					limit: limit, 
					count: 1, 
					order: '-createdAt'
				});

				yield* resp.results.map(item => {
					return all('tourMessage', {
						where: {
							tour: {__type: 'Pointer', className: 'Tour', objectId: item.objectId},
							read: false
						},
						limit: 1, 
						order: '-createdAt'
					}).then(message => {
						if (message.results.length > 0)
							item.hasMessages = true

						return item;
					});		
				})

				yield put({ type: 'queryFirst', payload: {
					tours: resp.results, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'Tour', {...payload, include: 'client,client.hotel,createdBy'})

				yield* resp.results.map(item => {
					return all('tourMessage', {
						where: {
							tour: {__type: 'Pointer', className: 'Tour', objectId: item.objectId},
							read: false
						},
						limit: 1, 
						order: '-createdAt'
					}).then(message => {
						if (message.results.length > 0)
							item.hasMessages = true

						return item;
					});		
				})

				yield put({ type: 'querySuccess', payload: {
					tours: resp.results,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*filter({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'Tour', {...payload, include: 'client,client.hotel,createdBy'})

				yield* resp.results.map(item => {
					return all('tourMessage', {
						where: {
							tour: {__type: 'Pointer', className: 'Tour', objectId: item.objectId},
							read: false
						},
						limit: 1, 
						order: '-createdAt'
					}).then(message => {
						if (message.results.length > 0)
							item.hasMessages = true

						return item;
					});		
				})

				yield put({ type: 'filterSuccess', payload: {
					tours: resp.results,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data = _.omit(data, ['objectId', 'createdBy', 'createdAt', 'updatedAt']);

				yield call(update, 'Tour', payload.objectId, data);
				yield put({ type: 'updateSuccess', 
					payload: {
						...data, 
						objectId: payload.objectId,
						activity: payload.activity,
						createdBy: payload.createdBy
					} 
				})
				message.success('Se ha actualizado la factura exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'Tour', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				tours: state.tours.concat(action.payload.tours),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				...state,
				tours: action.payload.tours,
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.tours, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			tours: _.without(state.tours, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/tour.js